import type { JSX } from 'react';

import reachAccess1360 from '#src/assets/nonprofit/reach-access-1360w.webp';
import reachAccess680 from '#src/assets/nonprofit/reach-access-680w.webp';
import reachAmplification1360 from '#src/assets/nonprofit/reach-amplification-1360w.webp';
import reachAmplification680 from '#src/assets/nonprofit/reach-amplification-680w.webp';
import reachInfluence1360 from '#src/assets/nonprofit/reach-influence-1360w.webp';
import reachInfluence680 from '#src/assets/nonprofit/reach-influence-680w.webp';

/** Max display width ~680px (desktop column); mobile full width. Lets browser pick 1x vs 2x. */
const IMG_SIZES = '(max-width: 767px) 100vw, 680px';

type SectionImageProps = { className?: string };

export function SupportersNetworkImage({ className }: SectionImageProps): JSX.Element {
	return (
		<img
			src={reachAccess680}
			srcSet={`${reachAccess680} 680w, ${reachAccess1360} 1360w`}
			sizes={IMG_SIZES}
			alt="Global network of activists finding new supporters and growing community"
			className={className}
			loading="lazy"
		/>
	);
}

export function MediaAmplificationImage({ className }: SectionImageProps): JSX.Element {
	return (
		<img
			src={reachAmplification680}
			srcSet={`${reachAmplification680} 680w, ${reachAmplification1360} 1360w`}
			sizes={IMG_SIZES}
			alt="Amplification through media network and journalists"
			className={className}
			loading="lazy"
		/>
	);
}

export function DecisionMakersImage({ className }: SectionImageProps): JSX.Element {
	return (
		<img
			src={reachInfluence680}
			srcSet={`${reachInfluence680} 680w, ${reachInfluence1360} 1360w`}
			sizes={IMG_SIZES}
			alt="Influencing decision makers who can deliver results"
			className={className}
			loading="lazy"
		/>
	);
}
